import { render, staticRenderFns } from "./update-group-icon.html?vue&type=template&id=1f8d21bd&scoped=true&external"
import script from "./update-group-icon.js?vue&type=script&lang=js&external"
export * from "./update-group-icon.js?vue&type=script&lang=js&external"
import style0 from "./update-group-icon.scss?vue&type=style&index=0&id=1f8d21bd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d21bd",
  null
  
)

export default component.exports